export const GreenDotIcon = () => {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle opacity="0.12" cx="8" cy="9" r="8" fill="#99A0AE" />
      <circle cx="8" cy="9" r="5" fill="#5CA198" />
    </svg>
  );
};
